module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_7016.b029e306.png";